import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import HeadingSkeleton from './HeadingSkeleton';
import ContactCompanyDetailsSkeleton from './ContactCompanyDetailsSkeleton';
import CrmObjectDetailsSkeleton from './CrmObjectDetailsSkeleton';
import { View } from 'foundations-components/components/View';
import CreateActivityButtonsSkeleton from 'crm-activity-creator-widgets/buttons/CreateActivityButtonsSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardSkeleton = ({
  objectTypeId,
  numberOfProperties
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(HeadingSkeleton, {}), /*#__PURE__*/_jsxs(View, {
      padding: "500",
      children: [objectTypeId === COMPANY_TYPE_ID || objectTypeId === CONTACT_TYPE_ID ? /*#__PURE__*/_jsx(ContactCompanyDetailsSkeleton, {
        numberOfProperties: numberOfProperties
      }) : /*#__PURE__*/_jsx(CrmObjectDetailsSkeleton, {
        numberOfProperties: numberOfProperties
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        marginBlockEnd: "-50",
        children: /*#__PURE__*/_jsx(CreateActivityButtonsSkeleton, {})
      })]
    })]
  });
};
export default CardSkeleton;